if (!window.customElements.get('xgen-results')) {
  class XGenResults extends HTMLElement {
    /*
    static get observedAttributes() {
      return ['data-query'];
    }
      */
    constructor() {
      super()
      this.abortController = null;
    }
    connectedCallback() {
      this.url = new URL(window.location.href);
      const filterSettingsEl = document.querySelector('[data-filter-settings]');
      if (filterSettingsEl) {
        try {
          this.filterSettings = JSON.parse(filterSettingsEl.textContent);
        } catch (e) {
          this.filterSettings = [];
        }
      } else {
        this.filterSettings = [];
      }

      this.normalizeTagalysUrl();

      this.deploymentId = this.getAttribute('data-deployment-id');

      const paramQ = this.url.searchParams.get('q');
      const paramQuery = this.url.searchParams.get('query');
      const dataQuery = this.getAttribute('data-query');
      this.query = dataQuery || paramQ || paramQuery || '';

      if (this.query) {
        document.querySelectorAll('[data-search-key]').forEach(el => {
          if (!el.textContent.trim()) el.textContent = this.query;
        });
      }

      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const desktopPageSize = parseInt(this.getAttribute('data-page-size')) || 60;
      const mobilePageSize = parseInt(this.getAttribute('data-page-size-mobile')) || desktopPageSize;
      this.pageSize = isMobile ? mobilePageSize : desktopPageSize;

      this.collection = this.getAttribute('data-collection') || false
      this.displayOnlyDefined = this.getAttribute('data-display-only-defined') && this.getAttribute('data-display-only-defined') !== 'false'
      this.facetsSetting = true
      this.page = 0
      this.getPreviousPages = false
      this.discreetePromises = {}
      this.context = {
        facets: {},
      }
      this.expandedFacets = new Set()
      this.clearInternalState()
      this.productPool = []
      this.productsFetched = 0
      this.itemsRendered = 0
      if (this.collection) this.context.collection = this.collection

      this.setInitialFilters()

      if (!this.query && !this.collection) {
        this.render({ totalResults: 0, items: [] });
      } else {
        this.get();
      }

      this.attachSorting()
      this.attachViewingTypes()
      this.attachPagination()
      this.attachFilterToggles()
      //this.attachFiltering()
      document.addEventListener('click', () => this.saveScrollPosition())

      // XGen Tracking - searchClick: prevent nav, await tracking, then navigate
      this.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="/products/"]');
        if (!link) return;
        const card = e.target.closest('.product-card') || link.querySelector('.product-card');
        if (!card || !this.contains(card)) return;
        const jsonScript = card.querySelector('[data-product-json]');
        if (!jsonScript) return;
        //e.preventDefault();
        try {
          const product = JSON.parse(jsonScript.textContent);
          const itemId = product.id;
          const allProductCards = this.querySelectorAll('.product-card');
          const allItemIds = Array.from(allProductCards).map(el => {
            const script = el.querySelector('[data-product-json]');
            return script ? JSON.parse(script.textContent).id : null;
          }).filter(Boolean);
          window.xgenCommon.pushEvent({
            event: 'searchClick',
            data: {
              query: this.query,
              queryId: window.xgenQueryId['main-results'] || 'main-results',
              deploymentId: this.deploymentId || window.xgen_vars.xgen_search_deployment_id,
              page: this.page + 1,
              item: itemId,
              items: allItemIds
            }
          });
        } catch (err) {
          console.warn('XGen Tracking Error:', err);
        }
        //window.location.href = link.href;
      });
    }

    normalizeTagalysUrl() {
      const urlParams = this.url.searchParams;
      const tagalysQuery = urlParams.get('query');
      const tagalysFilter = urlParams.get('filter');

      // If neither tagalys query nor tagalys filter exists, no need for normalization
      if (!tagalysQuery && !tagalysFilter) return;

      const newParams = new URLSearchParams(urlParams);

      // Handle query -> q
      if (tagalysQuery) {
        newParams.set('q', tagalysQuery);
        newParams.delete('query');
      }

      // Handle filter
      if (tagalysFilter) {
        const filters = tagalysFilter.split('~');
        filters.forEach(f => {
          const parts = f.split('-');
          if (parts.length < 2) return;
          const tagalysKey = parts[0];
          const valuesStr = parts.slice(1).join('-');
          // Tagalys uses _ for spaces, XGen uses spaces (which URLSearchParams encodes as +)
          const values = valuesStr.split(',').map(v => v.replace(/_/g, ' '));

          if (tagalysKey === 'sale_price' || tagalysKey === 'price') {
            // Tagalys format: price-5-15
            if (values[0]) newParams.set('filter_price_min', values[0]);
            if (values[1]) newParams.set('filter_price_max', values[1]);
          } else {
            const setting = this.filterSettings.find(s => s.tagalys_param === tagalysKey);
            const xgenKey = setting ? setting.name : tagalysKey;
            newParams.set(`filter_${xgenKey}`, values.join(','));
          }
        });
        newParams.delete('filter');
      }

      // Construct the new URL
      const newUrl = new URL(this.url.origin + this.url.pathname);
      newUrl.search = newParams.toString();

      // Update URL without reload if it changed
      if (newUrl.toString() !== this.url.toString()) {
        window.history.replaceState(null, '', newUrl.toString());
        this.url = newUrl;
      }
    }

    normalize(value) {
      return String(value ?? "").trim().toLowerCase();
    }

    matchGroupName(gName, fName) {
      if (!gName || !fName) return false;
      const gn = this.normalize(gName);
      const fn = this.normalize(fName);
      if (gn === fn) return true;
      if (gn === fn + 's' || fn === gn + 's') return true;
      if ((gn === 'price_range' && fn === 'price') || (gn === 'price' && fn === 'price_range')) return true;
      if (gn.startsWith(fn) || fn.startsWith(gn)) return true;
      return false;
    }

    hashCode(s) {
      return s.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0);
    }

    clearInternalState() {
      this._visibilityCache = {};
      this._knownOptions = {};
      this._openFacetDetails = new Set();
      this.discreetePromises = {};
      this.productPool = [];
      this.productsFetched = 0;
      this.itemsRendered = 0;
    }

    restoreScrollPosition() {
      if (sessionStorage.getItem('scrollPosition')) {
        const scrollPosition = JSON.parse(sessionStorage.getItem('scrollPosition'))
        if (scrollPosition[window.location.pathname]) {
          window.scrollTo(0, scrollPosition[window.location.pathname])
        }
      }
    }
    saveScrollPosition() {
      const scrollPosition = JSON.parse(sessionStorage.getItem('scrollPosition')) || {}
      scrollPosition[window.location.pathname] = window.scrollY
      try {
        sessionStorage.setItem('scrollPosition', JSON.stringify(scrollPosition))
      } catch (e) {
      }
    }
    getApiVariableType(key) {
      if (!this.filterSettings || !this.filterSettings.length) return 'array';
      const normalize = (v) => this.normalize(v);
      const matchGroupName = (g, f) => this.matchGroupName(g, f);
      const normalizedKey = normalize(key);
      const setting = this.filterSettings.find(s => {
        if (matchGroupName(s.name, normalizedKey) || matchGroupName(s.original_name, normalizedKey)) return true;
        if (s.facet_type === 'price_range' && (matchGroupName(s.min_variable, normalizedKey) || matchGroupName(s.max_variable, normalizedKey))) return true;
        return false;
      });
      return setting && setting.api_variable_type ? setting.api_variable_type : 'array';
    }

    getApiContext() {
      if (!this.context) return undefined;
      const apiContext = {};
      Object.keys(this.context).forEach(key => {
        const valArr = this.context[key];
        if (key === 'collection' || key === 'facets') {
          apiContext[key] = valArr;
        } else if (Array.isArray(valArr)) {
          const type = this.getApiVariableType(key);
          if (type === 'number') {
            apiContext[key] = Number(valArr[0]);
          } else if (type === 'string') {
            apiContext[key] = valArr.length > 0 ? valArr.join(',') : "";
          } else if (type === 'boolean') {
            apiContext[key] = valArr[0] === 'true' || valArr[0] === '1';
          } else {
            apiContext[key] = valArr;
          }
        } else {
          apiContext[key] = valArr;
        }
      });
      return apiContext;
    }

    getFacetCacheHash(searchObject) {
      if (!searchObject) return null;

      const sortObjectKeys = (obj) => {
        if (typeof obj !== 'object' || obj === null) return obj;
        if (Array.isArray(obj)) return obj.map(sortObjectKeys);
        return Object.keys(obj).sort().reduce((acc, key) => {
          acc[key] = sortObjectKeys(obj[key]);
          return acc;
        }, {});
      };

      const facetState = {
        query: searchObject.query || '',
        context: sortObjectKeys(searchObject.options && searchObject.options.context ? searchObject.options.context : {}),
        sortBy: searchObject.options && searchObject.options.sortBy ? searchObject.options.sortBy : false,
        sortOrder: searchObject.options && searchObject.options.sortOrder ? searchObject.options.sortOrder : false
      };
      return this.hashCode(JSON.stringify(facetState));
    }

    isFacetOpen(k) {
      if (!this._openFacetDetails || this._openFacetDetails.size === 0) return true;
      return Array.from(this._openFacetDetails).some(id => this.matchGroupName(id, k));
    }

    getSearchObject() {
      const searchObject = {
        options: {
          collection: (window.xgen_vars && window.xgen_vars.locales && window.xgen_vars.locales.includes('en-' + window.xgen_vars.locale)) ? 'en-' + window.xgen_vars.locale : 'default',
          deploymentId: this.deploymentId,
          pageSize: this.pageSize + 8,
          facets: this.facetsSetting,
          perform_new_faceting: true
        },
      }
      if (this.query) searchObject.query = this.query
      searchObject.queryId = 'main-results'
      if (this.sortBy) searchObject.options.sortBy = this.sortBy
      if (this.sortOrder) searchObject.options.sortOrder = this.sortOrder
      if (this.page) searchObject.options.page = this.page
      if (this.context) searchObject.options.context = this.getApiContext()
      return searchObject;
    }

    get() {
      this.productWrap = this.querySelector('[data-main-results] [data-product-wrap]') || this.querySelector('[data-product-wrap]') || this;

      // Abort previous in-flight request
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      const searchObject = this.getSearchObject();
      const hash = this.hashCode(JSON.stringify(searchObject))

      if (this.getPreviousPages) {
        const pageToFetch = parseInt(this.url.searchParams.get('page'))
        const productsToGet = (this.pageSize * pageToFetch) + 8;
        const batchSize = 120;
        const fetchesToMake = Math.ceil(productsToGet / batchSize);

        Promise.all(Array.from({ length: fetchesToMake }, (_, i) => {
          const pSearchObject = JSON.parse(JSON.stringify(searchObject));
          pSearchObject.options.page = i;
          pSearchObject.options.pageSize = batchSize;
          return window.xgenCommon.search(pSearchObject, { signal });
        })).then(results => {
          if (signal.aborted) return;
          let mergedItems = [];
          results.forEach(result => {
            if (result && result.items) mergedItems = mergedItems.concat(result.items);
          });

          const finalResult = results[0];
          finalResult.items = mergedItems.slice(0, productsToGet);
          this.render(finalResult);
          this.restoreScrollPosition();
        }).catch(e => {
          if (e.name === 'AbortError') return;
          console.error('XGen search error', e);
        });

        this.getPreviousPages = false
      } else {
        const hash = this.hashCode(JSON.stringify(searchObject))
        if (this.discreetePromises && this.discreetePromises[hash]) {
          this.discreetePromises[hash].then(results => {
            if (signal.aborted) return;
            this.render(results)
          })
        } else {
          // --- BEGIN EXACT DISJUNCTIVE BACKGROUND LOGIC ---
          const bgKeys = Object.keys(this.context).filter(k =>
            k !== 'collection' &&
            k !== 'facets' &&
            k !== 'price_min' &&
            k !== 'price_max' &&
            this.context[k].length > 0 &&
            this.isFacetOpen(k)
          );

          let searchPromise;
          if (bgKeys.length > 0) {
            const mainSearchPromise = window.xgenCommon.search(JSON.parse(JSON.stringify(searchObject)), { signal });

            const backgroundPromises = bgKeys.map(key => {
              const bgSearchObject = JSON.parse(JSON.stringify(searchObject));
              if (bgSearchObject.options.context) {
                if (Array.isArray(bgSearchObject.options.context)) {
                  bgSearchObject.options.context = bgSearchObject.options.context.filter(c => c.name !== key);
                } else {
                  delete bgSearchObject.options.context[key];
                }
              }
              bgSearchObject.options.pageSize = 1;
              bgSearchObject.options.page = 0;
              bgSearchObject.queryId = `bg-facet-${key}-${this.hashCode(JSON.stringify(bgSearchObject.options.context))}`;

              const bgFacetHash = this.getFacetCacheHash(bgSearchObject);

              // Check if we already have a promise for this exact facet state in flight
              if (this.discreetePromises && this.discreetePromises[bgFacetHash]) {
                return this.discreetePromises[bgFacetHash].then(res => ({ key, res })).catch(e => null);
              }

              if (this.facetDataCache && this.facetDataCache[bgFacetHash]) {
                return Promise.resolve({ key, res: this.facetDataCache[bgFacetHash] });
              }

              const bgPromise = window.xgenCommon.search(bgSearchObject, { signal }).then(res => {
                if (res && this.facetDataCache) this.facetDataCache[bgFacetHash] = res;
                return { key, res };
              }).catch(e => null);

              // Also store background promises in the discreete cache to prevent parallel duplicates
              if (this.discreetePromises) this.discreetePromises[bgFacetHash] = bgPromise.then(r => r ? r.res : null);

              return bgPromise;
            });

            searchPromise = Promise.all([mainSearchPromise, Promise.all(backgroundPromises)]).then(([mainResults, bgResults]) => {
              if (mainResults) {
                if (mainResults.queryId) window.xgenQueryId['main-results'] = mainResults.queryId
                // Cache main results facets
                const mainFacetHash = this.getFacetCacheHash(searchObject);
                if (this.facetDataCache) this.facetDataCache[mainFacetHash] = mainResults;

                mainResults.disjunctiveFacets = {};
                bgResults.forEach(bg => {
                  if (bg && bg.res) mainResults.disjunctiveFacets[bg.key] = bg.res;
                });
              }
              return mainResults;
            });
          } else {
            searchPromise = window.xgenCommon.search(searchObject, { signal }).then(res => {
              if( res ) {
                console.log('RAW SDK mainResults', res)
                if (res.queryId) window.xgenQueryId['main-results'] = res.queryId
                if (this.facetDataCache) {
                  const mainFacetHash = this.getFacetCacheHash(searchObject);
                  this.facetDataCache[mainFacetHash] = res;
                }
              }
              return res;
            });
          }

          this.discreetePromises[hash] = searchPromise;
          searchPromise.then(results => {
            if (signal.aborted) return;
            this.render(results)
          }).catch(e => {
            if (e.name === 'AbortError') return;
            console.error('XGen search error', e);
          });
          // --- END EXACT DISJUNCTIVE BACKGROUND LOGIC ---
        }
      }
    }
    resetPage() {
      this.page = 0
      this.url.searchParams.delete('page')
      window.history.replaceState(null, '', this.url)
      this.productPool = []
      this.productsFetched = 0
      this.itemsRendered = 0
    }
    setInitialFilters() {
      this.sortSelect = this.querySelector('select[name="sort"]')
      this.sortSelectOverlay = this.querySelector('[data-sort-option-current]')
      const urlParams = window.location.search.replace('?', '').split('&')
      if (urlParams && urlParams.length) {
        urlParams.forEach(param => {
          const [key, value] = param.split('=')
          const decodedValue = decodeURIComponent(value).replace(/\+/g, ' ')
          if (key.indexOf('filter_') === 0) {
            if (key === "filter_sort") {
              this.sortBy = decodedValue.split('__')[0]
              this.sortOrder = decodedValue.split('__')[1]
              if (this.sortSelect) this.sortSelect.value = decodedValue
              if (this.sortSelectOverlay && window.xgen_vars.sortOptions && window.xgen_vars.sortOptions[decodedValue]) {
                this.sortSelectOverlay.innerText = window.xgen_vars.sortOptions[decodedValue]
              }
            } else {
              const name = key.replace('filter_', '')
              this.context[name] = decodedValue.split(',')
            }
          } else if (key === "page") {
            this.page = decodedValue - 1
            if (this.page > 1) this.getPreviousPages = true
          } else if (key === "filter") {
            const filters = decodedValue.split('~')
            filters.forEach(filter => {
              const filterValues = filter.split('-')
              const filterName = filterValues[0]
              let values = filterValues.join('-').split(',')
              let name = filterName
              if (filterName === 'sale_price' || filterName === 'price') {
                if (filterValues[1]) this.context['min_price'] = filterValues[1]
                if (filterValues[2]) this.context['max_price'] = filterValues[2]
              } else {
                this.context[name] = values
              }
            })
          }
        })
      }

      if (this.filterSettings && this.filterSettings.length > 0) {
        this.filterSettings.forEach(setting => {
          if (setting.default_hidden_values && setting.default_hidden_values.length) {
            this.context[setting.name] = setting.default_hidden_values;
          }
        });
      }
    }
    attachFiltering() {
      Object.keys(this.context).forEach(key => {
        if (key === "collection" || key === "facets") return
        const values = this.context[key];
        if (!values || !values.length) return;
        const input = this.facetsWrap.querySelector(`[name="filter_${key}"][value="${values.join(',')}"]`);
        if (input) {
          if (input.type === "checkbox" || input.type === "radio") input.checked = true
          else input.value = this.context[key].join(',')
        } else {
          values.forEach(value => {
            const input = this.facetsWrap.querySelector(`[name="filter_${key}"][value="${value}"]`);
            if (input) {
              if (input.type === "checkbox" || input.type === "radio") input.checked = true
              else input.value = this.context[key].join(',')
            }
          })
        }
      })
      const hasAnyChecked = this.facetsWrap.querySelectorAll('input[type="checkbox"]:checked').length > 0
      this.facetsWrap.querySelectorAll('details[data-filter-id]').forEach(details => {
        const hasDetailsChecked = details.querySelectorAll('input[type="checkbox"]:checked').length > 0
        if (hasDetailsChecked) {
          details.open = true
        }
      })
      this.facetsWrap.querySelectorAll('.show_more_click').forEach(showMore => {
        showMore.addEventListener('click', (e) => {
          e.preventDefault()
          const facetId = e.target.closest('details[data-filter-id]').getAttribute('data-filter-id')
          this.expandedFacets.add(facetId)
          e.target.closest('.filter-checkboxes').querySelectorAll('li:nth-child(n+7)').forEach(li => {
            li.style.display = 'list-item'
          })
          e.target.parentElement.style.display = 'none'
          e.target.closest('.filter-checkboxes').querySelector('.show_less').style.display = 'inline-block'
        })
      })
      this.facetsWrap.querySelectorAll('.show_less_click').forEach(showLess => {
        showLess.addEventListener('click', (e) => {
          e.preventDefault()
          const facetId = e.target.closest('details[data-filter-id]').getAttribute('data-filter-id')
          this.expandedFacets.add(facetId)
          e.target.closest('.filter-checkboxes').querySelectorAll('li:nth-child(n+7)').forEach(li => {
            li.style.display = 'none'
          })
          e.target.parentElement.style.display = 'none'
          e.target.closest('.filter-checkboxes').querySelector('.show_more').style.display = 'inline-block'
          this.expandedFacets.delete(facetId)
        })
      })

      this.facetsWrap.querySelectorAll('.filter-checkbox__input').forEach(filterCheckbox => {
        filterCheckbox.addEventListener('change', (e) => {
          this.resetPage()
          const name = filterCheckbox.name.replace('filter_', '')
          this.context[name] = this.context[name] || []

          if (filterCheckbox.type === 'radio') {
            if (filterCheckbox.value === '') {
              this.context[name] = [];
            } else {
              this.context[name] = [filterCheckbox.value];
            }
          } else {
            if (filterCheckbox.checked) {
              this.context[name].push(filterCheckbox.value)
            } else {
              this.context[name] = this.context[name].filter(value => value !== filterCheckbox.value)
            }
          }

          if (this.context[name].length === 0) {
            this.url.searchParams.delete('filter_' + name)
            delete this.context[name]
          } else {
            this.url.searchParams.set('filter_' + name, this.context[name].join(','))
          }
          window.history.replaceState(null, '', this.url)
          this.get()
        })
      })

      this.facetsWrap.querySelectorAll('range-slider').forEach(slider => {
        slider.addEventListener('range-change', (e) => {
          const { minVar, maxVar, minPrice, maxPrice } = e.detail;
          const min = minPrice !== '' && minPrice !== null ? minPrice : false;
          const max = maxPrice !== '' && maxPrice !== null ? maxPrice : false;

          this.resetPage()

          if (min !== false) {
            this.context[minVar] = [min];
            this.url.searchParams.set(`filter_${minVar}`, min);
          } else {
            delete this.context[minVar];
            this.url.searchParams.delete(`filter_${minVar}`);
          }

          if (max !== false) {
            this.context[maxVar] = [max];
            this.url.searchParams.set(`filter_${maxVar}`, max);
          } else {
            delete this.context[maxVar];
            this.url.searchParams.delete(`filter_${maxVar}`);
          }

          window.history.replaceState(null, '', this.url)
          this.get()
        });
      });

      const closeItems = this.facetsWrap.querySelectorAll('.close-filter, .apply-filter-count');
      closeItems.forEach(btn => {
        btn.addEventListener('click', () => {
          document.body.classList.remove('filter-drawer-opened');
          document.documentElement.classList.remove('filter-drawer-opened');
          document.body.classList.remove('xgen-no-scroll');
        });
      });

      const clearBtn = this.querySelectorAll('.clear-all-filters-btn');
      clearBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          this.resetPage();
          Object.keys(this.context).forEach(key => {
            if (key !== 'collection' && key !== 'facets') {
              delete this.context[key];
              this.url.searchParams.delete('filter_' + key);
            }
          });
          window.history.replaceState(null, '', this.url);
          document.body.classList.remove('filter-drawer-opened');
          document.documentElement.classList.remove('filter-drawer-opened');
          document.body.classList.remove('xgen-no-scroll');
          this.clearInternalState();
          this.get();
        });
      });

      this.querySelectorAll('[data-applied-filters-wrap]').forEach(appliedFiltersWrap => {
        appliedFiltersWrap.addEventListener('click', (e) => {
          if (e.target.closest('.applied-filter-action-clear') || e.target.classList.contains('applied-filter-action-clear')) {
            const filterEl = e.target.closest('.applied-filter');
            const filterName = filterEl.getAttribute('data-filter-name');
            const filterValue = filterEl.getAttribute('data-filter-value');
            if (filterName === 'price') {
              this.url.searchParams.delete('filter_price_min');
              this.url.searchParams.delete('filter_price_max');
              delete this.context['price_min'];
              delete this.context['price_max'];
            } else {
              if (this.context[filterName] && this.context[filterName].length > 1) {
                this.context[filterName] = this.context[filterName].filter(v => v !== filterValue);
                this.url.searchParams.set('filter_' + filterName, this.context[filterName].join(','));
              } else {
                this.url.searchParams.delete('filter_' + filterName);
                delete this.context[filterName];
              }
            }
            window.history.replaceState(null, '', this.url);
            //document.body.classList.remove('filter-drawer-opened');
            //document.documentElement.classList.remove('filter-drawer-opened');
            //document.body.classList.remove('xgen-no-scroll');
            this.get();
          }
        });
      })
    }

    attachFilterToggles() {
      const hideFilterBtn = this.querySelector('.hide-filter');
      const showFilterBtn = this.querySelector('.show-filter');
      const facetsWrap = this.querySelector('[data-facets-wrap]');
      const viewingWrap = this.querySelector('[data-viewing-wrap]');

      if (hideFilterBtn && showFilterBtn && facetsWrap && viewingWrap) {
        hideFilterBtn.addEventListener('click', () => {
          hideFilterBtn.style.display = 'none';
          showFilterBtn.style.display = 'flex';
          facetsWrap.classList.add('hide');
          viewingWrap.classList.remove('medium-up--four-fifths');
          viewingWrap.classList.add('medium-up--one-whole');
        });

        showFilterBtn.addEventListener('click', () => {
          showFilterBtn.style.display = 'none';
          hideFilterBtn.style.display = 'flex';
          facetsWrap.classList.remove('hide');
          viewingWrap.classList.remove('medium-up--one-whole');
          viewingWrap.classList.add('medium-up--four-fifths');
        });
      }

      const mobileFilterBtn = this.querySelector('.collection__tab--filter');
      if (mobileFilterBtn) {
        mobileFilterBtn.addEventListener('click', (e) => {
          document.body.classList.add('filter-drawer-opened');
          document.documentElement.classList.add('filter-drawer-opened');
          document.body.classList.add('xgen-no-scroll');
        });
      }

      this.querySelectorAll('details[data-filter-id]').forEach(details => {
        details.addEventListener('toggle', (e) => {
          if (this._isRendering) return; // Ignore toggles triggered by re-rendering

          const filterId = details.getAttribute('data-filter-id');
          if (!this._openFacetDetails) this._openFacetDetails = new Set();

          if (details.open) {
            this._openFacetDetails.add(filterId);
            // If this group has active filters, we might need to fetch disjunctive counts
            if (this.context[filterId] && this.context[filterId].length > 0) {
              const bgSearchObject = JSON.parse(JSON.stringify(this.getSearchObject()));
              // Simulate the BG context by removing this key
              if (bgSearchObject.options.context) delete bgSearchObject.options.context[filterId];

              const hash = this.getFacetCacheHash(bgSearchObject);
              if (!this.facetDataCache[hash] && (!this.discreetePromises || !this.discreetePromises[hash])) {
                this.get();
              }
            }
          } else {
            this._openFacetDetails.delete(filterId);
          }
        });
      });
    }


    attachViewingTypes() {
      this.viewingTypes = this.querySelectorAll('[data-viewing-type]') || false;
      if (!this.viewingTypes) {
        return
      }
      this.viewingWrap = this.querySelector('[data-viewing-wrap]') || false;
      if (!this.viewingWrap) {
        this.viewingTypes.forEach(viewingType => {
          viewingType.style.display = 'none'
        })
        return
      } else {
        this.viewingTypes.forEach(viewingType => {
          viewingType.style.display = ''
        })
      }

      const storedType = localStorage.getItem('collectionViewType');
      if (storedType === 'view-3') {
        this.viewingType = '3';
      } else if (storedType === 'view-4') {
        this.viewingType = '4';
      } else {
        this.viewingType = '4';
        try {
          localStorage.setItem('collectionViewType', 'view-4');
        } catch (err) { }
      }

      if (this.querySelector('[data-viewing-type="' + this.viewingType + '"]')) {
        this.viewingTypes.forEach(viewingType => {
          viewingType.classList.remove('active');
          this.viewingWrap.classList.remove('type-' + viewingType.getAttribute('data-viewing-type'));
        });
        this.querySelector('[data-viewing-type="' + this.viewingType + '"]').classList.add('active');
        this.viewingWrap.classList.add('type-' + this.viewingType);
      }

      this.viewingTypes.forEach(viewingType => {
        viewingType.addEventListener('click', () => {
          this.viewingType = viewingType.getAttribute('data-viewing-type');
          const localStorageValue = this.viewingType === '3' ? 'view-3' : 'view-4';
          try {
            localStorage.setItem('collectionViewType', localStorageValue);
          } catch (e) { }
          this.viewingTypes.forEach(viewingTypeInner => {
            viewingTypeInner.classList.remove('active');
            this.viewingWrap.classList.remove('type-' + viewingTypeInner.getAttribute('data-viewing-type'));
          });
          viewingType.classList.add('active');
          this.viewingWrap.classList.add('type-' + this.viewingType);
        });
      });
    }
    attachSorting() {
      if (!this.sortSelect) return
      this.sortSelect.addEventListener('change', () => {
        this.resetPage()
        const sortBy = this.sortSelect.value.split('__')[0]
        const sortOrder = this.sortSelect.value.split('__')[1]
        if (sortBy === "default") {
          this.sortBy = false
          this.sortOrder = false
          this.url.searchParams.delete('filter_sort')
        } else {
          this.sortBy = sortBy
          this.sortOrder = sortOrder
          this.url.searchParams.set('filter_sort', sortBy + '__' + sortOrder)
        }
        if (this.sortSelectOverlay && window.xgen_vars.sortOptions && window.xgen_vars.sortOptions[this.sortSelect.value]) {
          this.sortSelectOverlay.innerText = window.xgen_vars.sortOptions[this.sortSelect.value]
        }
        window.history.replaceState(null, '', this.url)
        this.get()
      })
    }
    attachPagination() {
      this.paginationWrap = this.querySelector('[data-pagination]') || false;
      if (!this.paginationWrap) return
      this.paginationWrap.querySelector('.load-next').addEventListener('click', () => {
        if (this.productPool && this.productPool.length > 0) {
          const items = this.fillItems(8, this.itemsRendered + 1);
          this.productWrap.insertAdjacentHTML('beforeend', items.join(''));

          if (this.productWrap.querySelectorAll('.product-card:not([data-inited])').length > 0) {
            this.productWrap.querySelectorAll('.product-card:not([data-inited])').forEach(productCard => {
              new window.theme.ProductCard(productCard);
              productCard.setAttribute('data-inited', true)
            })
          }

          if (this.querySelector('[data-viewed-products]')) {
            const viewedProductsSpan = this.querySelector('[data-viewed-products]');
            if (viewedProductsSpan) viewedProductsSpan.textContent = this.productWrap.querySelectorAll('.product-card').length;
          }
          if (this.paginationProgress && this.totalResultsForProgress) {
            const viewed = this.productWrap.querySelectorAll('.product-card').length;
            this.paginationProgress.style.width = (viewed / this.totalResultsForProgress) * 100 + '%';
          }

          const skeletonsHtml = Array.from({ length: this.pageSize }).map((_, i) => `
            <div class="grid__item medium-up--one-fifth load-more-skeleton">
                <div class="product-card" style="--animationDelay: ${i * 0.25}s;">
                  <div class="product-card__image">
                    <div class="product-card__image--cover skeleton-bg"></div>
                  </div>
                  <div class="product-card__info">
                    <div class="product-card__details">
                      <div class="product-card__text">
                        <h4 class="product-card__title">
                          <span class="skeleton-text skeleton-bg">Loading...</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div class="product-card__price">
                    <span class="skeleton-text skeleton-bg">Loading</span>
                  </div>
                </div>
              </div>
           `).join('');
          this.productWrap.insertAdjacentHTML('beforeend', skeletonsHtml);
        }

        this.page = this.page + 1
        this.url.searchParams.set('page', this.page + 1)
        window.history.replaceState(null, '', this.url)
        this.get()
      })
    }
    updatePagination(results) {
      this.totalResultsForProgress = results.totalResults;
      this.paginationWrap = this.querySelector('[data-pagination]') || false;
      this.paginationProgress = this.querySelector('[data-pagination-progress]') || false;

      const hasMoreItems = this.productPool.length > 0 || results.totalResults > this.productsFetched;

      if (this.paginationWrap) {
        if (hasMoreItems) {
          this.paginationWrap.style.display = ''
        } else {
          this.paginationWrap.style.display = 'none'
        }
      }
      if (this.paginationProgress) {
        let viewed = this.productWrap.querySelectorAll('.product-card').length;
        const progress = results.totalResults > 0 ? (viewed / results.totalResults) * 100 : 0;
        this.paginationProgress.style.width = progress + '%'
      }
    }
    renderFacets(results) {
      const facets = results?.facets || results?.facet_list || [];
      if (!Array.isArray(facets) || !facets.length) return "";

      const normalize = (v) => this.normalize(v);
      const matchGroupName = (g, f) => this.matchGroupName(g, f);

      const facetContextMap = facets.reduce((acc, facet) => {
        if (facet?.name) acc[normalize(facet.name)] = facet;
        return acc;
      }, {});

      // Build the union of all facet dimension names across every API group,
      // so we never miss a filter category that the first group happens to omit.
      const allDimensionNames = new Set();
      facets.forEach(group => {
        Object.keys(group.facets || {}).forEach(dim => allDimensionNames.add(dim));
      });

      let facetsToProcess = [];
      if (allDimensionNames.size) {
        facetsToProcess = Array.from(allDimensionNames).map((name) => ({ name }));
      } else {
        facetsToProcess = facets.map((facet) => ({ ...facet }));
      }

      let facetsToRender = facetsToProcess
        .map((facet, index) => {
          const apiFacetName = facet?.name;
          const originalFacetName = apiFacetName?.split('-')[0] || apiFacetName;
          const normalizedFacetName = normalize(originalFacetName);

          let facetName = originalFacetName;
          let isOpen = index === 0;
          let isHidden = this.displayOnlyDefined ? true : false;
          let hiddenValues = [];
          let defaultHiddenValues = [];
          let facetType = 'checkboxes';
          let onOffValues = [];
          let minVariable = 'price_min';
          let maxVariable = 'price_max';

          if (this.filterSettings && this.filterSettings.length > 0) {
            const matchingSetting = this.filterSettings.find((s) => {
              const settingName = normalize(s?.name);
              const settingOriginalName = normalize(s?.original_name);
              return (
                settingName === normalizedFacetName ||
                settingOriginalName === normalizedFacetName
              );
            });

            if (matchingSetting) {
              isHidden = !!matchingSetting.hidden;
              if (matchingSetting.custom_label) {
                facetName = matchingSetting.custom_label;
              }
              hiddenValues = Array.isArray(matchingSetting.hidden_values) ? matchingSetting.hidden_values : [];
              defaultHiddenValues = Array.isArray(matchingSetting.default_hidden_values) ? matchingSetting.default_hidden_values : [];
              isOpen = !!matchingSetting.open;
              facetType = matchingSetting.facet_type || 'checkboxes';
              onOffValues = Array.isArray(matchingSetting.on_off_values) ? matchingSetting.on_off_values : [];
              if (matchingSetting.min_variable) minVariable = matchingSetting.min_variable;
              if (matchingSetting.max_variable) maxVariable = matchingSetting.maxVariable;
            }
          }

          return {
            ...facet,
            facetName,
            isOpen,
            isHidden,
            hiddenValues,
            defaultHiddenValues,
            facetType,
            onOffValues,
            minVariable,
            maxVariable
          };
        })
        .filter((f) => !f.isHidden);

      if (this.filterSettings && this.filterSettings.length > 0) {
        facetsToRender.sort((a, b) => {
          const originalA = normalize(a?.name?.split('-')[0]);
          const originalB = normalize(b?.name?.split('-')[0]);

          const indexA = this.filterSettings.findIndex((s) => normalize(s?.name) === originalA);
          const indexB = this.filterSettings.findIndex((s) => normalize(s?.name) === originalB);

          if (indexA !== -1 && indexB !== -1) return indexA - indexB;
          if (indexA !== -1) return -1;
          if (indexB !== -1) return 1;
          return 0;
        });
      }

      this.context = this.context || {};
      facetsToRender.forEach((setting) => {
        if (setting.defaultHiddenValues && setting.defaultHiddenValues.length) {
          this.context[setting.name] = setting.defaultHiddenValues;
        }
      });

      // Create a mapping from URL parameter names to facet names using filterSettings
      const urlParamToFacetName = new Map();
      if (this.filterSettings && this.filterSettings.length > 0) {
        this.filterSettings.forEach(setting => {
          const settingName = normalize(setting?.name);
          const settingOriginalName = normalize(setting?.original_name);
          // Map both the name and original_name to the normalized name
          urlParamToFacetName.set(settingName, settingName);
          if (settingOriginalName !== settingName) {
            urlParamToFacetName.set(settingOriginalName, settingName);
          }
        });
      }

      const activeFacetGroups = new Set();
      this.url.searchParams.forEach((value, key) => {
        if (!key.startsWith('filter_')) return;
        let urlParam = normalize(key.replace('filter_', '').split('-')[0]);

        // Map min/max price URL params to the internal price_range group
        if (urlParam === 'price_min' || urlParam === 'price_max') {
          urlParam = 'price_range';
        }

        // Use the mapping to get the correct facet name
        const facetName = urlParamToFacetName.get(urlParam) || urlParam;
        if (facetName) activeFacetGroups.add(facetName);
      });

      const isFacetActiveObj = (normalizedFacetName) => {
        return Array.from(activeFacetGroups).some(g => matchGroupName(g, normalizedFacetName));
      };

      // Find the last active group index (the one with the most recent filter applied)
      let lastActiveGroupIndex = -1;
      activeFacetGroups.forEach(groupName => {
        const groupIndex = facets.findIndex(f => matchGroupName(f.name, groupName));
        if (groupIndex > lastActiveGroupIndex) {
          lastActiveGroupIndex = groupIndex;
        }
      });

      const apiGroupIndexByName = new Map();
      facets.forEach((f, i) => {
        if (f.name) apiGroupIndexByName.set(normalize(f.name), i);
      });


      if (!this._knownOptions) this._knownOptions = {};

      const clearAllHtml = () => {
        return `<li class="applied-filter filter__label clear-all-filters">
      <button type="button" class="clear-all-filters-btn">
        <span class="filter__label applied-filter-label">Clear all</span>
      </button>
    </li>`;
      };

      const formatApiPrice = (val) => {
        try {
          const priceVariable = parseFloat(val) * 100;
          if (isNaN(priceVariable)) return val;
          return `<em class="currency-symbol">${window.theme.currentCurrencySymbol}</em>${slate.Currency.formatMoney(priceVariable, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "").replace("$", "")}`;
        } catch (e) {
          return val;
        }
      };

      const appliedFilterHtml = (f) => {
        if (f.name == "sort") return "";

        let displayValue = f.value;
        if (f.name.toLowerCase().includes("price")) {
          if (String(f.value).includes('-') && !String(f.value).startsWith('-')) {
            displayValue = String(f.value).split('-').map(v => formatApiPrice(v)).join(' - ');
          } else {
            displayValue = formatApiPrice(f.value);
          }
        }

        return `<li class="display-flex applied-filter" data-filter-name="${f.name}" data-filter-value="${f.value}">
          <span class="filter__label applied-filter-label">${displayValue}</span>
          <span class="filter__label applied-filter-action-clear">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Exclude" fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM8.39406 3.76859C8.59945 3.98896 8.58731 4.33411 8.36694 4.5395L6.77087 6.02708L8.25845 7.62315C8.46384 7.84352 8.45169 8.18867 8.23132 8.39406C8.01095 8.59945 7.6658 8.58731 7.46041 8.36694L5.97283 6.77087L4.37676 8.25845C4.15639 8.46384 3.81124 8.45169 3.60585 8.23132C3.40046 8.01095 3.4126 7.6658 3.63297 7.46041L5.22904 5.97283L3.74146 4.37676C3.53607 4.15639 3.54822 3.81124 3.76859 3.60585C3.98896 3.40046 4.33411 3.4126 4.5395 3.63297L6.02708 5.22904L7.62315 3.74146C7.84352 3.53607 8.18867 3.54822 8.39406 3.76859Z" fill="#333333"></path>
            </svg>
          </span>
        </li>`;
      };

      this.desktopAppliedFilterWrap = document.querySelector('.collection__products > [data-applied-filters-wrap]');

      const allCheckedFacets = [];
      this.url.searchParams.forEach((value, key) => {
        if (key.startsWith('filter_')) {
          value.split(',').forEach((v) => {
            const cleanKey = key.replace('filter_', '');
            const mappedName = urlParamToFacetName.get(cleanKey) || cleanKey;
            allCheckedFacets.push({ name: cleanKey, apiName: mappedName, value: v });
          });
        }
      });

      const checkedFacets = []
      let priceMin = false
      let priceMax = false
      allCheckedFacets.forEach((f) => {
        if (f.name === 'sort') {
          return
        }
        if (f.name === 'price_max') {
          priceMax = f.value
          return
        }
        if (f.name === 'price_min') {
          priceMin = f.value
          return
        }
        checkedFacets.push(f)
      })

      if (priceMin && priceMax) {
        checkedFacets.push({ name: 'price', value: `${priceMin}-${priceMax}` })
      }

      if (this.desktopAppliedFilterWrap) {
        if (checkedFacets.length) {
          this.desktopAppliedFilterWrap.classList.remove('hide');
          const wrap = this.desktopAppliedFilterWrap.querySelector('[data-applied-filters]');
          if (wrap) {
            wrap.innerHTML = checkedFacets.map((f) => appliedFilterHtml(f)).join('') + clearAllHtml();
          }
        } else {
          this.desktopAppliedFilterWrap.classList.add('hide');
          const wrap = this.desktopAppliedFilterWrap.querySelector('[data-applied-filters]');
          if (wrap) wrap.innerHTML = '';
        }
      }

      const hasActiveFilters = activeFacetGroups.size > 0;
      const showFilterCounts = window.theme.showFilterItemsCount !== false;

      return `<div class="collection_tg_filter_mobile_footer">
        <div class="filter__label clear-all-filters">
          <button type="button" class="clear-all-filters-btn">Clear</button>
        </div>
        <div class="apply-filter-count">Apply<span class="mobile-totalCount">(<span data-results-count>${results?.totalResults ?? 0}</span>)</span></div>
      </div>

      <div class="collection_tg_filter_mobile_header">
        <div>
          ${this.query}
        </div>
        <button class="close-filter filter-drawer-toggle">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="close" d="M1.369 0.234883C1.05582 -0.0782944 0.548061 -0.0782944 0.234883 0.234883C-0.0782944 0.548061 -0.0782944 1.05582 0.234883 1.369L4.86588 6L0.234931 10.631C-0.0782463 10.9441 -0.0782466 11.4519 0.234931 11.7651C0.548109 12.0782 1.05587 12.0782 1.36905 11.7651L6 7.13412L10.631 11.7651C10.9441 11.4519 11.4519 11.4519 11.7651 11.7651C12.0782 11.4519 12.0782 10.9441 11.7651 10.631L7.13412 6L11.7651 1.369C12.0783 1.05582 12.0783 0.548061 11.7651 0.234883C11.4519 -0.0782944 10.9442 -0.0782944 10.631 0.234883L6 4.86588L1.369 0.234883Z" fill="#333333"></path>
          </svg>
        </button>
      </div>

      ${checkedFacets.length ? `<div data-applied-filters-wrap class="mobile-appliedFilters collection__filter-actions">
        <ul data-applied-filters class="applied-filters unstyled-list">
          ${checkedFacets.map((f) => appliedFilterHtml(f)).join('')}
          ${clearAllHtml()}
        </ul>
      </div>` : ''}

      <div class="collection-filters-block">
        ${facetsToRender.map((facet, index) => {
        const apiFacetName = facet?.name;
        const originalFacetName = apiFacetName?.split('-')[0] || apiFacetName;
        const normalizedFacetName = normalize(originalFacetName);
        const facetName = facet?.facetName;

        if (!facet || !facetName || !apiFacetName || !originalFacetName) return '';

        const facetValueNames = apiFacetName.split('-')[1]
          ? apiFacetName.split('-')[1].split('+')
          : [originalFacetName];

        const facetType = facet.facetType || 'checkboxes';
        const onOffValues = Array.isArray(facet.onOffValues) && facet.onOffValues.length ? facet.onOffValues : [];
        const isCurrentFacetActive = isFacetActiveObj(normalizedFacetName);

        let mappedIndex = undefined;
        for (let [gName, idx] of apiGroupIndexByName.entries()) {
          if (matchGroupName(gName, apiFacetName) || matchGroupName(gName, originalFacetName)) {
            mappedIndex = idx;
            break;
          }
        }
        const groupApiIndex = mappedIndex !== undefined ? mappedIndex : Math.min(index, facets.length - 1);
        const checkedFacets = allCheckedFacets.filter(f => matchGroupName(f.apiName, apiFacetName) || matchGroupName(f.name, apiFacetName)).map(f => f.value);

        // State Cache: Track the exact current state of ALL OTHER selected filters
        const otherActiveFiltersArray = allCheckedFacets
          .filter(f => !matchGroupName(f.apiName, apiFacetName) && !matchGroupName(f.name, apiFacetName))
          .map(f => `${f.apiName}:${f.value}`)
          .sort();
        const otherActiveFiltersHash = otherActiveFiltersArray.join('|');

        let allFacets = {};
        facetValueNames.forEach((facetValueName) => {
          let searchName = facetValueName;
          if (searchName === 'price_range') searchName = 'price';

          // Find the "self" group index — the API group whose name matches
          // this facet dimension.
          const selfGroupIndex = facets.findIndex(g => {
            return matchGroupName(g.name, searchName) || matchGroupName(g.name, normalizedFacetName);
          });

          // Determine which groups to use for calculating counts:
          // - Always use the last active group as the base (AND logic between groups)
          // - If no active groups, use all groups (full AND intersection)
          let maxIndex;
          if (lastActiveGroupIndex !== -1) {
            // Use groups up to the last active group
            maxIndex = lastActiveGroupIndex;
          } else if (selfGroupIndex !== -1) {
            // No active groups, use groups up to the self-group
            maxIndex = selfGroupIndex;
          } else {
            // No self-group, use all groups
            maxIndex = facets.length - 1;
          }

          // Collect all possible option keys from considered groups
          const keys = new Set();
          for (let i = 0; i <= Math.max(maxIndex, selfGroupIndex !== -1 ? selfGroupIndex : 0); i++) {
            const source = facets[i].facets || {};
            const resolved = source[searchName] || source[normalize(searchName)];
            if (resolved) Object.keys(resolved).forEach(k => keys.add(k));
          }

          // Implement exact XGen FacetManager sourceIndex logic
          // 1. Find deepestActiveApiGroupIndex
          let deepestActiveApiGroupIndex = -1;
          activeFacetGroups.forEach(gName => {
            const idx = facets.findIndex(f => matchGroupName(f.name, gName));
            if (idx > deepestActiveApiGroupIndex) deepestActiveApiGroupIndex = idx;
          });


          this._visibilityCache = this._visibilityCache || {};

          // 2. Resolve sourceIndex per group
          let sourceIndex;
          if (!isCurrentFacetActive) {
            if (deepestActiveApiGroupIndex === -1) {
              sourceIndex = selfGroupIndex >= 0 ? selfGroupIndex : 0;
            } else {
              sourceIndex = deepestActiveApiGroupIndex;
            }
          } else {
            sourceIndex = selfGroupIndex >= 0 ? selfGroupIndex : 0;
          }
          // Ensure we don't go out of bounds
          sourceIndex = Math.min(sourceIndex, facets.length - 1);


          keys.forEach(k => {
            let minCount = Infinity;

            // Disjunctive Facet Bypass (Holy Grail): If this exact facet is actively selected AND we fetched a background 
            // payload physically bypassing it, we extract the MATHEMATICALLY PERFECT counts out of `disjunctiveFacets`!
            let bgGroupFound = false;
            if (isCurrentFacetActive && results.disjunctiveFacets && results.disjunctiveFacets[apiFacetName]) {
              const bgGroups = results.disjunctiveFacets[apiFacetName].facets || [];
              // Because the facet was bypassed, the VERY LAST group possesses the exact counts filtered by all OTHER active choices!
              const bgDeepest = bgGroups.length > 0 ? bgGroups[bgGroups.length - 1] : {};
              const bgSource = bgDeepest.facets || {};
              const bgResolved = bgSource[searchName] || bgSource[normalize(searchName)];
              if (bgResolved) {
                minCount = bgResolved[k] !== undefined ? bgResolved[k] : 0;
                bgGroupFound = true;
              }
            }

            if (!bgGroupFound) {
              // Split Resolution: If this specific option is currently selected, its TRUE mathematical
              // count resides in the deepest active filter boundary (because the intersection of all
              // selected groups perfectly reflects the items matching this exact selection).
              // If it's UNSELECTED, we must pull from the pre-self sourceIndex to prevent it from collapsing.
              if (checkedFacets.includes(k)) {
                const deepSourceIdx = deepestActiveApiGroupIndex !== -1 ? deepestActiveApiGroupIndex : sourceIndex;
                const deepSourceIndex = Math.min(Math.max(deepSourceIdx, 0), facets.length - 1);

                const deepSource = facets[deepSourceIndex].facets || {};
                const deepResolved = deepSource[searchName] || deepSource[normalize(searchName)] || {};
                minCount = deepResolved[k] !== undefined ? deepResolved[k] : 0;
              } else if (sourceIndex >= 0) {
                // Read from the exact sourceIndex snapshot matching XGen's official client
                const source = facets[sourceIndex].facets || {};
                const resolved = source[searchName] || source[normalize(searchName)] || {};
                const count = resolved[k] !== undefined ? resolved[k] : 0;
                minCount = count;
              }
            }

            if (minCount === Infinity) {
              const firstSource = facets[0].facets || {};
              const firstResolved = firstSource[searchName] || firstSource[normalize(searchName)] || {};
              minCount = firstResolved[k] !== undefined ? firstResolved[k] : 0;
            }
            allFacets[k] = minCount === Infinity ? 0 : minCount;
          });

          // When a facet is INACTIVE, the deepest snapshot represents its TRUE physical availability.
          // We FREEZE these perfectly valid keys to memory.
          if (!isCurrentFacetActive) {
            const deepest = deepestActiveApiGroupIndex !== -1 ? deepestActiveApiGroupIndex : Math.min(Math.max(selfGroupIndex - 1, 0), facets.length - 1);
            const perfectSource = facets[deepest].facets || {};
            const perfectResolved = perfectSource[searchName] || perfectSource[normalize(searchName)] || {};
            this._visibilityCache[normalizedFacetName] = {
              hash: otherActiveFiltersHash,
              array: otherActiveFiltersArray,
              keys: Object.keys(perfectResolved).filter(k => perfectResolved[k] > 0)
            };
          }
        });


        if (!this._knownOptions[normalizedFacetName]) this._knownOptions[normalizedFacetName] = new Set();
        Object.keys(allFacets).forEach(k => this._knownOptions[normalizedFacetName].add(k));
        checkedFacets.forEach(checkedVal => {
          this._knownOptions[normalizedFacetName].add(checkedVal);
        });
        this._knownOptions[normalizedFacetName].forEach(k => {
          if (!(k in allFacets)) allFacets[k] = 0;
        });

        if (facet.hiddenValues && facet.hiddenValues.length) {
          allFacets = Object.fromEntries(
            Object.entries(allFacets).filter(([key]) => !facet.hiddenValues.includes(key))
          );
        }

        if (facet.defaultHiddenValues && facet.defaultHiddenValues.length) {
          allFacets = Object.fromEntries(
            Object.entries(allFacets).filter(([key]) => !facet.defaultHiddenValues.includes(key))
          );
        }

        const cache = this._visibilityCache[normalizedFacetName];

        const facetEntries = Object.entries(allFacets)
          .filter(([value, count]) => {
            const numericCount = Number(count ?? 0);

            if (numericCount <= 0 && !checkedFacets.includes(value)) {
              return false;
            }

            // State Cache Override: Sub-filter mathematically impossible options.
            // If the current filters are a SUPERSET of the cached filters, the physical impossibilities
            // frozen in the cache are guaranteed to STILL be impossible, so we keep the surgical purge active!
            if (isCurrentFacetActive && cache) {
              const isSuperset = cache.array.every(cachedFilter => otherActiveFiltersArray.includes(cachedFilter));
              if (isSuperset) {
                if (!cache.keys.includes(value) && !checkedFacets.includes(value)) {
                  return false;
                }
              }
            }

            return true;
          })
          .sort(([a], [b]) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

        if (!facetEntries.length && apiFacetName !== 'price_range' && normalizedFacetName !== 'price_range') return '';

        if (facetType === 'checkbox') {
          const toggleValue = onOffValues.join('+');
          return `<div class="collection__filter filter toggle-filter filter-item filter-checkboxes" style="padding: 10px 0; border-bottom: none;">
              <label class="filter__type filter-checkbox-and-label" style="display: flex; align-items: center; cursor: pointer;">
                <input name="filter_${apiFacetName}" data-name="${apiFacetName}" value="${toggleValue}" type="checkbox" class="filter-checkbox__input" ${onOffValues[0] && checkedFacets.includes(onOffValues[0]) ? 'checked' : ''}>
                <span class="filter-item-label-and-count" style="margin-left: 10px;">
                  <span class="filter-item-label" style="font-weight: bold; font-size: 1.1em;">${facetName}</span>
                </span>
              </label>
            </div>`;
        }

        const isRadios = facetType === 'radios';
        const showMoreThreshold = 6;
        const isPriceRange = apiFacetName === 'price_range' || normalizedFacetName === 'price_range' || facetType === 'price_range';

        if (isPriceRange) {
          const minVarName = facet.minVariable || 'price_min';
          const maxVarName = facet.maxVariable || 'price_max';
          let minPrice = facet.minPrice || 0;
          let maxPrice = facet.maxPrice || 1000;

          const priceKeys = Object.keys(allFacets).map(k => parseFloat(k)).filter(k => !isNaN(k));
          if (priceKeys.length > 0) {
            minPrice = Math.floor(Math.min(...priceKeys));
            maxPrice = Math.ceil(Math.max(...priceKeys));
          }

          const currentMin = this.url.searchParams.get(`filter_${minVarName}`) || minPrice;
          const currentMax = this.url.searchParams.get(`filter_${maxVarName}`) || maxPrice;

          const isPriceActive = this.url.searchParams.has(`filter_${minVarName}`) || this.url.searchParams.has(`filter_${maxVarName}`);

          if (!isPriceActive && results.totalResults < 5) {
            return '';
          }

          const isOpen = facet.isOpen || isPriceActive || this.expandedFacets.has(apiFacetName);

          return `<details data-filter-id="${apiFacetName}" class="collection__filter filter" ${isOpen ? 'open="true"' : ''}>
              <summary class="filter__label filter-header filter-header--toggle">
                <h3 class="filter-heading filter__button">${facetName}</h3>
                <div class="filter-actions">
                  <span class="filter-action-toggle-collapse">
                    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 4" class="icon icon--wide icon-chevron-down">
                      <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
                    </svg>
                    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 13 6" class="icon icon--wide icon-chevron-up-2">
                      <path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path>
                    </svg>
                  </span>
                </div>
              </summary>
              
              <div class="filter__list filter-body filter-body-range">
                <range-slider data-min-var="${minVarName}" data-max-var="${maxVarName}" data-min-val="${minPrice}" data-max-val="${maxPrice}">
                  <div class="range-slider filter-item">
                    <div class="price-range__input-group">
                      <div class="min-price">
                        <span class="min-label">Min</span>
                        <div class="price-range__input input-prefix input-container">
                          <span class="input-prefix__value">${window.theme.currentCurrencySymbol || '$'}</span>
                          <input id="priceRangeMin-${apiFacetName}" type="number" name="filter_price_min" inputmode="numeric" placeholder="${minPrice}" value="${currentMin}" aria-label="Price Range Input" class="input-prefix__field field__input pr-input">
                          <label for="priceRangeMin-${apiFacetName}" style="display: none;">&lt;sup&gt;${window.theme.currentCurrencySymbol || '$'}&lt;/sup&gt;${currentMin}</label>
                        </div>
                      </div>
                      <div class="min-price">
                        <span class="min-label">Max</span>
                        <div class="price-range__input input-prefix input-container">
                          <span class="input-prefix__value">${window.theme.currentCurrencySymbol || '$'}</span>
                          <input id="priceRangeMax-${apiFacetName}" type="number" name="filter_price_max" inputmode="numeric" placeholder="${maxPrice}" value="${currentMax}" class="input-prefix__field field__input pr-input">
                          <label for="priceRangeMax-${apiFacetName}" style="display: none;">&lt;sup&gt;${window.theme.currentCurrencySymbol || '$'}&lt;/sup&gt;${currentMax}</label>
                        </div>
                      </div>
                    </div>
                    <div class="sliders_control">
                      <input id="priceRangeSliderMin-${apiFacetName}" class="from-slider" type="range" value="${currentMin}" min="${minPrice}" max="${maxPrice}"/>
                      <input id="priceRangeSliderMax-${apiFacetName}" class="to-slider" type="range" value="${currentMax}" min="${minPrice}" max="${maxPrice}"/>
                    </div>
                  </div>
                </range-slider>
              </div>
            </details>`;
        }

        const wasOpen = this._openFacetDetails && this._openFacetDetails.has(apiFacetName);
        const shouldBeOpen = facet.isOpen || wasOpen || checkedFacets.length > 0;

        //console.log('normalizedFacetName', normalizedFacetName)
        const isColourFacet = normalizedFacetName === 'colour' || normalizedFacetName === 'colours' || normalizedFacetName === 'color' || normalizedFacetName === 'colors';

        return `<details data-filter-id="${apiFacetName}" class="collection__filter filter" ${shouldBeOpen ? 'open="true"' : ''}>
            <summary class="filter__label filter-header filter-header--toggle">
              <h3 class="filter-heading filter__button">${facetName}</h3>
              <div class="filter-actions">
                <span class="filter-action-toggle-collapse">
                  <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 4" class="icon icon--wide icon-chevron-down">
                    <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
                  </svg>
                  <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 13 6" class="icon icon--wide icon-chevron-up-2">
                    <path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path>
                  </svg>
                </span>
              </div>
            </summary>

            <div class="filter__list filter-body filter-body-checkboxes ${isColourFacet ? 'colour' : normalizedFacetName}">
              <ul class="filter-checkboxes">
                ${isRadios ? `<li class="filter-item">
                  <label class="filter__type filter-checkbox-and-label">

                    <input name="filter_${apiFacetName}" data-name="${apiFacetName}" value="" type="radio" class="filter-checkbox__input" ${checkedFacets.length === 0 ? 'checked' : ''}>
                    <span class="filter-item-label-and-count">
                      <span class="filter-item-label">All</span>
                    </span>
                  </label>
                </li>` : ''}

                ${facetEntries.map(([value, count], itemIndex) => {
          let colour_icon = `<span></span>`;
          let icon = "";
          let code = "";

          const filterName = String(value.trim()).toLowerCase();


          if (window.plp_vars?.coloursMeta?.[filterName]) {
            if (window.plp_vars.coloursMeta[filterName].icon) {
              icon = window.plp_vars.coloursMeta[filterName].icon;
            } else if (window.plp_vars.coloursMeta[filterName].code) {
              code = window.plp_vars.coloursMeta[filterName].code;
            }
          }

          if (isColourFacet) {
            if (icon !== "") {
              colour_icon = `<span class="colour-icon"><img width="16" height="16" loading="lazy" src="${icon}" /></span>`;
            } else if (code !== "") {
              colour_icon = `<span class="colour-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="Colour">
                            <circle cx="8" cy="8" r="8" fill="${code}"></circle>
                          </g>
                        </svg>
                      </span>`;
            }
          }

          //console.log('filterName', filterName, isColourFacet, icon, code, colour_icon)


          const isExpanded = this.expandedFacets.has(apiFacetName);
          const hiddenByShowMore = itemIndex >= 6 && !isExpanded;

          let displayValue = value;
          if (apiFacetName.toLowerCase().includes('price')) {
            try {
              let priceVariable = parseFloat(value) * 100;
              if (!isNaN(priceVariable)) {
                displayValue = `<em class="currency-symbol">${window.theme.currentCurrencySymbol}</em>${slate.Currency.formatMoney(priceVariable, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "").replace("$", "")}`;
              }
            } catch (e) {
              console.warn('XGen Error formatting money', e);
            }
          }

          if (isColourFacet) {
            return `<li data-filter-item-id="${filterName}" class="filter-item colour" ${hiddenByShowMore ? 'style="display: none;"' : isExpanded && itemIndex >= 6 ? 'style="display: list-item;"' : ''}>
                    <label class="filter__type filter-checkbox-and-label ${filterName}">
                      ${colour_icon}
                      <input name="filter_${apiFacetName}" data-name="${apiFacetName}" value="${value}" type="${isRadios ? 'radio' : 'checkbox'}" class="filter-checkbox__input checkbox" ${checkedFacets.includes(value) ? 'checked' : ''}>
                      <span class="filter-item-label-and-count">
                        <span class="filter-item-label">${displayValue}</span>${showFilterCounts ? `<span class="filter-item-count"> (${count})</span>` : ''}
                      </span>
                    </label>
                  </li>`;
          }

          return `<li class="filter-item" ${hiddenByShowMore ? 'style="display: none;"' : isExpanded && itemIndex >= 6 ? 'style="display: list-item;"' : ''}>
                    <label class="filter__type filter-checkbox-and-label">
                      ${colour_icon}
                      <input name="filter_${apiFacetName}" data-name="${apiFacetName}" value="${value}" type="${isRadios ? 'radio' : 'checkbox'}" class="filter-checkbox__input checkbox" ${checkedFacets.includes(value) ? 'checked' : ''}>
                      <span class="filter-item-label-and-count">
                        <span class="filter-item-label">${displayValue}</span>${showFilterCounts ? `<span class="filter-item-count"> (${count})</span>` : ''}
                      </span>
                    </label>
                  </li>`;
        }).join('')}

                ${facetEntries.length > showMoreThreshold ? `<li class="show_more" style="display: ${this.expandedFacets.has(apiFacetName) ? 'none' : 'inline-block'};"><button type="button" class="show_more_click">Show ${facetEntries.length - showMoreThreshold} More</button></li>` : ''}
                ${facetEntries.length > showMoreThreshold ? `<li class="show_less" style="display: ${this.expandedFacets.has(apiFacetName) ? 'inline-block' : 'none'};"><button type="button" class="show_less_click">Show Less</button></li>` : ''}
              </ul>
            </div>
          </details>`;
      }).join('')}
      </div>`;
    }
    fillItems(count, startPos) {
      const items = [];
      while (items.length < count && (this.productPool.length > 0 || (this.banners && this.banners[startPos + items.length]))) {
        const globalPos = startPos + items.length;
        if (this.banners && this.banners[globalPos]) {
          items.push(this.banners[globalPos]);
        } else if (this.productPool.length > 0) {
          const product = window.xgenCommon.unifyProduct(this.productPool.shift());
          items.push(window.renderProductCard(product, {
            gridSizing: 'medium-down--one-half large-up--one-whole'
          }));
        } else {
          // No more products in pool, and no banner at this position
          break;
        }
      }
      this.itemsRendered += items.length;
      return items;
    }

    saveBanners() {
      if (!this.banners) this.banners = {};
      const banners = this.querySelectorAll('[data-banner]');
      banners.forEach(banner => {
        const position = parseInt(banner.getAttribute('data-position'), 10);
        if (position) {
          this.banners[position] = banner.outerHTML;
        }
      });
    }

    render(results) {
      if (results && (results.url_redirect || results.urlRedirect)) {
        window.location.href = results.url_redirect || results.urlRedirect;
        return;
      }

      if (results) {
        if (results.total_result !== undefined && results.totalResults === undefined) results.totalResults = results.total_result;
        if (results.products_list !== undefined && results.items === undefined) results.items = results.products_list;
        results.totalResults = parseInt(results.totalResults) || 0;

        if (results.items) {
          this.productsFetched += results.items.length;
          this.productPool = this.productPool.concat(results.items);
        }
      }

      this.productWrap = this.querySelector('[data-main-results] [data-product-wrap]') || this.querySelector('[data-product-wrap]') || this;

      if (!this.banners) this.saveBanners();

      if (!results) return;

      if (results.totalResults < 12) {
        this.classList.add('results-small');
      } else {
        this.classList.remove('results-small');
      }

      this.facetsWrap = this.querySelector('[data-facets-wrap]') || false;
      if (this.facetsWrap) {
        if (!this._openFacetDetails) this._openFacetDetails = new Set();
        this.facetsWrap.querySelectorAll('details[data-filter-id][open]').forEach(d => {
          this._openFacetDetails.add(d.getAttribute('data-filter-id'));
        });
        this.facetsWrap.querySelectorAll('details[data-filter-id]:not([open])').forEach(d => {
          this._openFacetDetails.delete(d.getAttribute('data-filter-id'));
        });

        this._isRendering = true;
        this.facetsWrap.innerHTML = this.renderFacets(results)
        this.attachFiltering()
        this._isRendering = false;

        const hasFilters = this.facetsWrap.querySelector('.collection__filter') !== null;
        const hideFilterBtn = this.querySelector('.hide-filter');
        const showFilterBtn = this.querySelector('.show-filter');
        const viewingWrap = this.querySelector('[data-viewing-wrap]');
        const mobileFilterToggle = this.querySelector('#toggle-tg-filter');

        if (!hasFilters) {
          this.facetsWrap.style.display = 'none';
          if (hideFilterBtn) hideFilterBtn.style.display = 'none';
          if (showFilterBtn) showFilterBtn.style.display = 'none';
          if (mobileFilterToggle) mobileFilterToggle.style.display = 'none';
          if (viewingWrap) viewingWrap.classList.remove('medium-up--four-fifths');
        }
      }

      const isResetting = this.page === 0 || this.productWrap.querySelector('.product-card-skeleton');

      const mainResultsWrap = this.querySelector('[data-main-results]');
      const noResultsWrap = this.querySelector('[data-no-results]');

      const hasActiveFilters = (() => {
        let found = false;
        this.url.searchParams.forEach((value, key) => {
          if (key.startsWith('filter_') && key !== 'filter_sort') found = true;
        });
        return found;
      })();

      if (results.totalResults === 0 && this.page === 0) {
        if (hasActiveFilters) {
          if (mainResultsWrap) mainResultsWrap.classList.remove('hide');
          if (noResultsWrap) noResultsWrap.classList.add('hide');
          if (isResetting) {
            this.productWrap.innerHTML = `<div class="xgen-no-results-filtered">
              <p>${window.xgen_vars && window.xgen_vars.noResultsFilteredMessage
                ? window.xgen_vars.noResultsFilteredMessage
                : 'Sorry! We couldn’t find any results.'}</p>
            </div>`;
          }
          this.productWrap.classList.remove('loading');
        } else {
          if (mainResultsWrap) mainResultsWrap.classList.add('hide');
          if (noResultsWrap) {
            noResultsWrap.classList.remove('hide');
            const querySpan = noResultsWrap.querySelector('[data-no-results-query]');
            if (querySpan) querySpan.textContent = this.query;

            const noRecsTpl = this.querySelector('#no-results-rec-template');
            const noRecsWrapper = noResultsWrap.querySelector('.tg-no-result-products-wrapper');
            if (noRecsTpl && noRecsWrapper && !noRecsWrapper.querySelector('xgen-recommendations')) {
              noRecsWrapper.appendChild(noRecsTpl.content.cloneNode(true));
            }
          }
          if (isResetting) this.productWrap.innerHTML = '';
          this.productWrap.classList.remove('loading');
        }
      } else {
        if (mainResultsWrap) mainResultsWrap.classList.remove('hide');
        if (noResultsWrap) noResultsWrap.classList.add('hide');

        if (isResetting) {
          this.productWrap.innerHTML = '';
          this.itemsRendered = 0;
          let itemsToRenderCount = (this.page + 1) * this.pageSize;
          const items = this.fillItems(itemsToRenderCount, 1);
          this.productWrap.innerHTML = items.join('');
        } else {
          this.productWrap.querySelectorAll('.load-more-skeleton').forEach(el => el.remove());
          const items = this.fillItems(this.pageSize - 8, this.itemsRendered + 1);
          this.productWrap.insertAdjacentHTML('beforeend', items.join(''));
        }

        if (this.productWrap.querySelectorAll('.product-card:not([data-inited])').length > 0) {
          this.productWrap.querySelectorAll('.product-card:not([data-inited])').forEach(productCard => {
            new window.theme.ProductCard(productCard);
            productCard.setAttribute('data-inited', true)
          })
        }
      }

      this.updatePagination(results);

      if (this.querySelector('[data-results-count]')) {
        this.querySelectorAll('[data-results-count]').forEach(el => {
          el.textContent = results.totalResults
        })
      }
      if (this.querySelector('[data-viewed-products]')) {
        this.querySelectorAll('[data-viewed-products]').forEach(el => {
          const total = this.productWrap.querySelectorAll('.product-card').length
          el.textContent = total > results.totalResults ? results.totalResults : total
        })
      }
      this.productWrap.classList.remove('loading')

      if (results && results.items && results.items.find((item)=>{ return item.price_currency !== Shopify.currency.active }) && typeof window.getProductPrices === 'function') {
        console.log('XGen results not in currency ' + Shopify.currency.active + '. Fetching product prices.')
        const variantIds = [];
        results.items.forEach(item => {
          const product = window.xgenCommon.unifyProduct(item);
          if (product.variants) {
            product.variants.forEach(v => {
              if (v.id) {
                variantIds.push(v.id.toString().replace('gid://shopify/ProductVariant/', ''));
              }
            });
          }
        });
        if (variantIds.length) {
          window.getProductPrices([...new Set(variantIds)]);
        }
      }

      window.dispatchEvent(new CustomEvent('collection:rendered'));
    }
  }
  customElements.define('xgen-results', XGenResults);


  class RangeSlider extends HTMLElement {
    constructor() {
      super();
      this.minVar = this.getAttribute('data-min-var') || 'price_min';
      this.maxVar = this.getAttribute('data-max-var') || 'price_max';
      this.debounceTimer = null;
    }

    connectedCallback() {
      this.fromInput = this.querySelector('input[type="number"][name="filter_price_min"]');
      this.toInput = this.querySelector('input[type="number"][name="filter_price_max"]');
      this.fromSlider = this.querySelector('.from-slider');
      this.toSlider = this.querySelector('.to-slider');

      this.fillSlider(this.fromSlider, this.toSlider, '#e6e6e6', '#333', this.toSlider);
      this.setToggleAccessible(this.toSlider);

      this.fromSlider.oninput = () => this.controlFromSlider(this.fromSlider, this.toSlider, this.fromInput);
      this.toSlider.oninput = () => this.controlToSlider(this.fromSlider, this.toSlider, this.toInput);
      this.fromInput.oninput = () => this.controlFromInput(this.fromSlider, this.fromInput, this.toInput, this.toSlider);
      this.toInput.oninput = () => this.controlToInput(this.toSlider, this.fromInput, this.toInput, this.toSlider);

      const handleChange = () => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          let [from, to] = this.getParsed(this.fromInput, this.toInput);
          const minPossible = parseInt(this.toSlider.min || 0);
          const maxPossible = parseInt(this.toSlider.max || 1000);

          if (isNaN(from) || from < minPossible) from = minPossible;
          if (from > maxPossible) from = maxPossible;
          if (isNaN(to) || to > maxPossible) to = maxPossible;
          if (to < minPossible) to = minPossible;

          if (from > to) {
            [from, to] = [to, from];
          }

          this.fromInput.value = from;
          this.toInput.value = to;
          this.fromSlider.value = from;
          this.toSlider.value = to;
          this.fillSlider(this.fromSlider, this.toSlider, '#e6e6e6', '#333', this.toSlider);

          this.dispatchEvent(new CustomEvent('range-change', {
            detail: {
              minVar: this.minVar,
              maxVar: this.maxVar,
              minPrice: from,
              maxPrice: to
            },
            bubbles: true,
            composed: true
          }));
        }, 500); // 500ms debounce
      };

      this.fromSlider.addEventListener('change', handleChange);
      this.toSlider.addEventListener('change', handleChange);
      this.fromInput.addEventListener('change', handleChange);
      this.toInput.addEventListener('change', handleChange);
    }

    controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
      const [from, to] = this.getParsed(fromInput, toInput);
      this.fillSlider(fromInput, toInput, '#e6e6e6', '#333', controlSlider);
      if (!isNaN(from) && (isNaN(to) || from <= to)) {
        fromSlider.value = from;
      }
    }

    controlToInput(toSlider, fromInput, toInput, controlSlider) {
      const [from, to] = this.getParsed(fromInput, toInput);
      this.fillSlider(fromInput, toInput, '#e6e6e6', '#333', controlSlider);
      this.setToggleAccessible(toInput);
      if (!isNaN(to) && (isNaN(from) || from <= to)) {
        toSlider.value = to;
      }
    }

    controlFromSlider(fromSlider, toSlider, fromInput) {
      const [from, to] = this.getParsed(fromSlider, toSlider);
      this.fillSlider(fromSlider, toSlider, '#e6e6e6', '#333', toSlider);
      if (from > to) {
        fromSlider.value = to;
        fromInput.value = to;
      } else {
        fromInput.value = from;
      }
    }

    controlToSlider(fromSlider, toSlider, toInput) {
      const [from, to] = this.getParsed(fromSlider, toSlider);
      this.fillSlider(fromSlider, toSlider, '#e6e6e6', '#333', toSlider);
      this.setToggleAccessible(toSlider);
      if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
      } else {
        toInput.value = from;
        toSlider.value = from;
      }
    }

    getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }

    fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
      const minVal = parseInt(to.min || 0);
      const maxVal = parseInt(to.max || 1000);
      const rangeDistance = maxVal - minVal;
      const fromPosition = parseInt(from.value) - minVal;
      const toPosition = parseInt(to.value) - minVal;
      controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
        ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
        ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} 100%)`;
    }

    setToggleAccessible(currentTarget) {
      if (Number(currentTarget.value) <= 0) {
        this.toSlider.style.zIndex = 2;
      } else {
        this.toSlider.style.zIndex = 0;
      }
    }
  }
  customElements.define('range-slider', RangeSlider);
}